import { http, HttpResponse } from 'msw';
import { API, BASE_URL_V2 } from '../../../src/common/constants';
import type { AccountSubscriptionInfo } from '../../../src/store/facade/facadeApiV2';

const URL = `${BASE_URL_V2}${API.endpoints.accountSubscription}`;

export type SubscriptionConfig = {
    SRP: boolean;
    eMSP: boolean;
};

export const subscriptionHandler = (config: SubscriptionConfig) =>
    http.get(URL, () => {
        const response: AccountSubscriptionInfo = {
            srpSubscribed: config.SRP,
            emspSubscribed: config.eMSP,
        };
        return HttpResponse.json(response);
    });
